 {
    "fields": {
      "labels": {
        "status": "Status",
        "referenceNumber": "Referentienummer",
        "amount": "Leningbedrag",
        "startDate": "Startdatum",
        "collectionDate": "Incassodatum",
        "durationInDays": "Looptijd"
      }
    },
    "messages": {
      "collectionDateUpcoming": "Over {time} wordt deze lening geïncasseerd",
      "collectionDateToday": "Vandaag wordt deze lening geïncasseerd",
      "hasPendingRenewalRequest": "Verzoek tot verlengen ontvangen",
      "renewalUpcoming": "Lening wordt automatisch verlengd per incassodatum",
      "hasApprovedRenewalRequest": "Verzoek tot verlengen geaccepteerd, betaalinstructies verzonden naar de klant",
      "hasRequestedEarlyRepayment": "Verzoek tot eerder terugbetalen ontvangen.",
      "collectionPartiallyFailed": "Incasso's zijn deels mislukt",
      "collectionFullyFailed": "Incasso's zijn mislukt",
      "hasPausedExtraCost": "Vanwege de migratie zijn de extra kosten voor deze lening gepauzeerd."
    }
  }
